import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

export const useScoreValue = () => {
  const {t} = useTranslation();
  const {language} = useSelector((state) => state.common.settings);

  const currentScore = (score) => {
    switch (score) {
      case 5:
        return {
          grade: t("score.excellent.grade"),
          color: "#5EDE4D",
        };
      case 4:
        return {
          grade: t("score.good.grade"),
          color: "#FAE141",
        };
      case 3:
        return {
          grade: t("score.satisfactory.grade"),
          color: "#F8932D",
        };
      case 2:
        return {
          grade: t("score.room_for_improvement.grade"),
          color: "#F88B8B",
        };
      case 1:
        return {
          grade: t("score.requires_attention.grade"),
          color: "#EF4444",
        };
      default:
        return {
          grade: "",
          color: "transparent",
        };
    }
  };

  const getScoreEnding = (num) => {
    const pluralRules = new Intl.PluralRules(language);
    const form = pluralRules.select(num);

    switch (form) {
      case "one":
        return ` ${t("score.value.one")}`;

      case "few":
        return ` ${t("score.value.few")}`;

      case "many":
      case "other":
      default:
        return ` ${t("score.value.many")}`;
    }
  };

  const processFeedback = (html) => {
    if (!html) return html;

    return html.replace(
      /(<article>.*?<b>)(\d+)(<\/b>.*?<\/article>)/g,
      (match, before, number, after) => {
        const num = parseInt(number, 10);
        const ending = getScoreEnding(num);
        return `${before}${number}${ending}${after}`;
      },
    );
  };

  return {currentScore, processFeedback, getScoreEnding};
};
